import React, { useEffect, useState } from "react";
import PageRouter from "./PageRouter";
import Sidebar from "./Sidebar";

import bgmain from "../assets/images/bg-main.png";
import Topbar from "./Topbar";
import Footer from "./Footer";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import {
  changeLayoutDirection,
  changeLayoutMode,
  changeLayoutType,
  changeSidebarColor,
  changeLayoutTypeName,
  logoutUser,
} from "../slices/thunk";
import { LAYOUT_MODE } from "../Common/constants/layoutType";
import { useProfile } from "../Common/UserHooks";
import { setAuthorization } from "../helpers/api_helper";
import { useNavigate } from "react-router-dom";

const Layout = ({ children }: any) => {
  const dispatch = useDispatch<any>();
  const history : any = useNavigate();

  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser(history));
    }
  }, [token, userProfile, loading, history, dispatch]);

  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout: any) => ({
      currentLayoutMode: layout.currentLayoutMode,
      currentSidebarColor: layout.currentSidebarColor,
      currentLayoutDirection: layout.currentLayoutDirection,
      currentLayoutType: layout.currentLayoutType,
      currentLayoutTypeName: layout.currentLayoutTypeName
    })
  );

  // State from Redux
  const { currentLayoutMode, currentSidebarColor, currentLayoutDirection, currentLayoutType, currentLayoutTypeName } = useSelector(
    selectLayoutProperties
  );

  useEffect(() => {
    if (currentLayoutMode || currentSidebarColor || currentLayoutDirection || currentLayoutType || currentLayoutTypeName) {
      window.dispatchEvent(new Event("resize"));
      dispatch(changeLayoutMode(currentLayoutMode));
      dispatch(changeSidebarColor(currentSidebarColor))
      dispatch(changeLayoutDirection(currentLayoutDirection));
      dispatch(changeLayoutType(currentLayoutType));
      dispatch(changeLayoutTypeName(currentLayoutTypeName))
    }
  }, [currentLayoutMode, dispatch, currentLayoutDirection, currentLayoutType, currentLayoutTypeName, currentSidebarColor]);

  //  Dark & Light
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    const newMode =
      currentLayoutMode === LAYOUT_MODE.LIGHT
        ? LAYOUT_MODE.DARK
        : LAYOUT_MODE.LIGHT;

    // Dispatch the changeLayoutMode action
    dispatch(changeLayoutMode(newMode));
  };
  // Ltr & Rtl
  const [isDirection, setIsDirection] = useState(false);
  
  const toggleDirection = () => {
    setIsDirection(!isDirection);
    const newDirection = isDirection ? "ltr" : "rtl";
    dispatch(changeLayoutDirection(newDirection));
  };

  // lg sm Sidebar
  const [isSidebarSize, setIsSidebarSize] = useState(false);

  const toggleSidebarCollapse = () => {
    document.body.classList.toggle('toggle-sidebar');
    setIsSidebarSize(!isSidebarSize)
};


  return (
    <React.Fragment>
     <div className="bg-[#f9fbfd] dark:bg-dark text-black">
        {/* Start detached bg */}
        <div
          className="bg-black min-h-[220px] sm:min-h-[250px] bg-bottom fixed hidden w-full -z-50 detached-img"
          style={{ backgroundImage: `url(${bgmain})` }}
        ></div>
        {/* End detached bg */}

        {/* Start Menu Sidebar Overlay */}
        <div
        className={`fixed inset-0 bg-black/60 dark:bg-dark/90 z-10 lg:hidden ${isSidebarSize ? '' : 'hidden'}`}
        onKeyDown={toggleSidebarCollapse}
        onClick={toggleSidebarCollapse}
      ></div>
        {/* End Menu Sidebar Overlay */}

        <div className="flex mx-auto main-container">
          <Sidebar isSidebarSize={isSidebarSize} />
          <div className="flex-1 main-content">
            {/* Topbar */}
            <Topbar
              isDarkMode={isDarkMode}
              toggleDarkMode={toggleDarkMode}
              toggleSidebarCollapse={toggleSidebarCollapse}
            />
            <div className="h-[calc(100vh-60px)]  relative overflow-y-auto overflow-x-hidden p-4 space-y-4 detached-content">
              {children}
              {/* Footer */}
              <Footer />
            </div>
            <button
              type="button"
              className="fixed z-50 px-4 text-white border-gray-200 shadow-lg h-11 ltr:right-0 rtl:left-0 bg-purple ltr:rounded-l-md rtl:rounded-r-md top-1/3"
              onClick={toggleDirection}
            >
              {isDirection === false ? (
                <span className="rtl:hidden">RTL</span>
                ) : (
                <span className="ltr:hidden">LTR</span>
              )}
            </button>
          </div>
        </div>
      </div>
       {/* } */}
    </React.Fragment>
  );
};

export default PageRouter(Layout);
